// 2026 SAS Summer School application status helper.
// Deadline: 23:59:59 IST on 27 May 2026 == 18:30:00 UTC on 27 May 2026
// (transition into 28 May 2026 IST).
export const SUMMER_SCHOOL_DEADLINE_UTC = '2026-05-27T18:30:00Z';

export const APPLICATION_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSf6EEnIC3b-5_a-Qvwo5p6vCDiZYOoPZw7AhkJx1mdUH3S_JA/viewform';

export const isApplicationsClosed = () => {
  return new Date() >= new Date(SUMMER_SCHOOL_DEADLINE_UTC);
};
